import { render, staticRenderFns } from "./OperatorClosedWOs.vue?vue&type=template&id=a087803a&"
import script from "./OperatorClosedWOs.vue?vue&type=script&lang=js&"
export * from "./OperatorClosedWOs.vue?vue&type=script&lang=js&"
import style0 from "./OperatorClosedWOs.vue?vue&type=style&index=0&id=a087803a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports